import React from 'react';
import styled from 'styled-components';
import { PaddedContainer } from '../common/styles';

const Container = styled(PaddedContainer)`
  padding: ${props => (props.theme.isXLarge ? '65px 0 0 0' : '80px 0 68px 0')};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.span`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 20px;
  line-height: 20px;
  text-transform: uppercase;
`;

const Desc = styled.p`
  text-align: center;
  margin: 0;
  margin-top: 24px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightRegular};
  ${props => (props.theme.isMobile ? `
    font-size: 35px;
    line-height: 36px;
  ` : `
    font-size: 40px;
    line-height: 42px;
  `)};
`;

export default function Welcome() {
  return (
    <Container>
      <Title>welcome to livewire</Title>
      <Desc>Livewire is Australia’s #1 source of investment ideas</Desc>
    </Container>
  );
}
